import { makeStyles } from '@material-ui/core';
import { Colors } from '@rentguru/commons-utils';

import { MoreIcon } from '../../icons';
import { stopPropagation } from '../../utils/eventUtils';

const useStyles = makeStyles(() => ({
  icon: {
    cursor: 'pointer',
    fill: Colors.BLUE_GREY,
    height: 18,
    '&:hover': {
      backgroundColor: Colors.PORCELAIN_GREY_1,
      borderRadius: '50%',
    },
  },
}));

interface CustomTableActionsIconProps {
  onClick: () => void;
}

export const CustomTableActionsIcon = ({ onClick }: CustomTableActionsIconProps) => {
  const classes = useStyles();

  return (
    <MoreIcon
      className={classes.icon}
      onClick={(event) => {
        stopPropagation(event);
        onClick();
      }}
    />
  );
};
